import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const AboutContent: Content[] = [
  {
    title: 'O que é uma conta conectada?',
    description: `É uma conta autorizada a realizar transações de outras instituições financeiras no seu aplicativo, sem a necessidade de abrir um segundo app. Também é conhecida como "jornadas sem redirecionamento via Open Finance".`,
  },
  {
    title: 'Como funciona?',
    description: `A conta conectada pode fazer transações Pix por aproximação na sua carteira ou via Open Finance. Você concede uma única autorização para que as transações sejam realizadas sempre que desejar.`,
  },
  {
    title: 'O que é o Open Finance?',
    description: `Open Finance é um sistema gratuito no Inter que permite transações financeiras e compartilhamento seguro de dados entre instituições, sempre com a sua autorização.`,
  },
  {
    title: 'Posso encerrar uma autorização de conta conectada quando eu quiser?',
    description: `Sim, você pode encerrar uma autorização a qualquer momento.`,
  },
]

export const AboutAccountLink = () => (
  <S.Container>
    {AboutContent.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500} style={{ fontSize: 18 }}>
          {content.title}
        </Text>
        <Text variant="body-2" style={{ fontSize: 14 }}>
          {content.description}
        </Text>
      </S.Content>
    ))}
  </S.Container>
)
